module.exports = __webpack_public_path__ + "static/img/icon_s5.a38eb47.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_s5.png
// module id = 7pxh
// module chunks = 21